import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-10 bg-stone-900 text-stone-400 text-sm" data-id="element-42">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-4" data-id="element-43">
          <div className="flex items-center gap-6" data-id="element-44">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors duration-200" data-id="element-45">
              Privacy Policy
            </button>
            <span className="text-stone-600" data-id="element-46">·</span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors duration-200" data-id="element-47">
              Terms of Service
            </button>
          </div>
          <p className="text-stone-600" data-id="element-48">
            © {new Date().getFullYear()} 48-Hour Gut Reset. All rights
            reserved.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-49">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-50">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-8 py-5 border-b border-stone-200" data-id="element-51">
              <h3 className="text-xl font-serif font-medium text-stone-900" data-id="element-52">
                {activeModal === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}
              </h3>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-stone-100 transition-colors text-stone-500 hover:text-stone-900" data-id="element-53">
                <XIcon className="w-5 h-5" data-id="element-54" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="px-8 py-6 overflow-y-auto text-stone-700 leading-relaxed space-y-5" data-id="element-55">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-56" /> : <TermsContent data-id="element-57" />}
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-sm text-stone-500" data-id="element-58">Last updated: March 2026</p>

      <h4 className="font-semibold text-stone-900 text-lg" data-id="element-59">
        1. Information We Collect
      </h4>
      <p data-id="element-60">
        When you purchase the 48-Hour Gut Reset Planner, we collect only the
        information necessary to process your order: your name, email address,
        and payment details. Payment processing is handled by secure third-party
        providers — we never store your credit card information.
      </p>

      <h4 className="font-semibold text-stone-900 text-lg" data-id="element-61">
        2. How We Use Your Information
      </h4>
      <p data-id="element-62">
        We use your email address solely to deliver your digital product and
        send purchase-related communications. We do not sell, rent, or share
        your personal information with third parties for marketing purposes.
      </p>

      <h4 className="font-semibold text-stone-900 text-lg" data-id="element-63">3. Cookies</h4>
      <p data-id="element-64">
        Our website may use essential cookies to ensure proper functionality. We
        do not use tracking cookies for advertising purposes.
      </p>

      <h4 className="font-semibold text-stone-900 text-lg" data-id="element-65">4. Data Security</h4>
      <p data-id="element-66">
        We implement industry-standard security measures to protect your
        personal information. All transactions are encrypted using SSL
        technology.
      </p>

      <h4 className="font-semibold text-stone-900 text-lg" data-id="element-67">5. Your Rights</h4>
      <p data-id="element-68">
        You may request access to, correction of, or deletion of your personal
        data at any time by contacting us. We will respond to your request
        within 30 days.
      </p>

      <h4 className="font-semibold text-stone-900 text-lg" data-id="element-69">
        6. Changes to This Policy
      </h4>
      <p data-id="element-70">
        We reserve the right to update this Privacy Policy at any time. Changes
        will be posted on this page with an updated revision date.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-sm text-stone-500" data-id="element-71">Last updated: March 2026</p>

      <h4 className="font-semibold text-stone-900 text-lg" data-id="element-72">
        1. Product Description
      </h4>
      <p data-id="element-73">
        The 48-Hour Gut Reset Planner is a digital informational product (PDF)
        designed for educational purposes only. It is not a substitute for
        professional medical advice, diagnosis, or treatment. Always consult
        your physician before starting any new health protocol.
      </p>

      <h4 className="font-semibold text-stone-900 text-lg" data-id="element-74">
        2. Digital Delivery
      </h4>
      <p data-id="element-75">
        Upon successful payment, you will receive instant access to the digital
        PDF. Due to the nature of digital products, all sales are final. No
        refunds will be issued once the product has been delivered.
      </p>

      <h4 className="font-semibold text-stone-900 text-lg" data-id="element-76">
        3. Intellectual Property
      </h4>
      <p data-id="element-77">
        All content within the 48-Hour Gut Reset Planner is protected by
        copyright. You may not reproduce, distribute, or resell any part of this
        product without prior written consent.
      </p>

      <h4 className="font-semibold text-stone-900 text-lg" data-id="element-78">4. Disclaimer</h4>
      <p data-id="element-79">
        Results may vary from person to person. The information provided is
        based on general wellness principles and is not guaranteed to produce
        specific outcomes. We are not liable for any adverse effects or
        consequences resulting from the use of this product.
      </p>

      <h4 className="font-semibold text-stone-900 text-lg" data-id="element-80">
        5. Limitation of Liability
      </h4>
      <p data-id="element-81">
        To the maximum extent permitted by law, we shall not be held liable for
        any indirect, incidental, or consequential damages arising from the use
        of this product.
      </p>

      <h4 className="font-semibold text-stone-900 text-lg" data-id="element-82">6. Governing Law</h4>
      <p data-id="element-83">
        These terms shall be governed by and construed in accordance with
        applicable laws. Any disputes shall be resolved through binding
        arbitration.
      </p>
    </>;
}